var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8231 2.84873H14.2974V4.23843H12.9077V13.2715C12.9077 13.4557 12.8345 13.6325 12.7042 13.7628C12.5738 13.8931 12.3971 13.9663 12.2128 13.9663H2.48494C2.30065 13.9663 2.12391 13.8931 1.9936 13.7628C1.8633 13.6325 1.79009 13.4557 1.79009 13.2715V4.23843H0.400391V2.84873H3.87463V0.764185C3.87463 0.579899 3.94784 0.403162 4.07815 0.272852C4.20846 0.142543 4.3852 0.0693359 4.56948 0.0693359H10.1283C10.3126 0.0693359 10.4893 0.142543 10.6196 0.272852C10.7499 0.403162 10.8231 0.579899 10.8231 0.764185V2.84873ZM11.518 4.23843H3.17979V12.5766H11.518V4.23843ZM8.33139 8.40752L9.55989 9.63601L8.57737 10.6185L7.34888 9.39004L6.12039 10.6185L5.13787 9.63601L6.36636 8.40752L5.13787 7.17903L6.12039 6.19651L7.34888 7.425L8.57737 6.19651L9.55989 7.17903L8.33139 8.40752ZM5.26433 1.45903V2.84873H9.43342V1.45903H5.26433Z",
    fill: "#F34018"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.a8f79cc05a9aa280a1bd6fa257c80db5.svg";
export { ForwardRef as ReactComponent };